module.exports = __webpack_public_path__ + "static/media/logo-p7-pequeno.f22b5e18.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/logo-p7-pequeno.jpg
// module id = 1294
// module chunks = 0